import { Box, Flex, Text, Button } from '@chakra-ui/react';
import { useSteps } from 'react-step-builder';
import { Link } from 'react-router-dom';
import { useMixpanel } from '@/hooks/use-mixpanel';

export const Stats = ({ blueprint = {} }) => {
  const { next } = useSteps();
  const { track } = useMixpanel();
  return (
    <Flex
      h="80px"
      justifyContent="space-between"
      alignItems="center"
      borderBottomWidth="1px"
      pl="120px"
      pr="24px"
    >
      <Box textAlign="center">
        <Text fontSize="16px" fontWeight="semiBold">
          {blueprint?.steps}
        </Text>
        <Text variant="muted">Total Steps</Text>
      </Box>
      <Box textAlign="center">
        <Text fontSize="16px" fontWeight="semiBold">
          {blueprint?.days}
        </Text>
        <Text variant="muted">Days in Sequence</Text>
      </Box>
      <Box textAlign="center">
        <Text fontSize="16px" fontWeight="semiBold">
          {blueprint?.used}
        </Text>
        <Text variant="muted">Times used</Text>
      </Box>
      <Box textAlign="center">
        {!blueprint?.from_kula && (
          <Link to={`/blueprints/${blueprint?.id}`}>
            <Button mr="8px" variant="secondary">
              Edit
            </Button>
          </Link>
        )}
        <Button
          onClick={() => {
            track({
              event: 'outreach-create-from-blueprint',
            });
            next();
          }}
          data-tracking-id="create-from-blueprint"
        >
          Start from this Blueprint
        </Button>
      </Box>
    </Flex>
  );
};
